
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.333.668H9c.367 0 .667.3.667.666 0 .367-.3.667-.667.667H1a.669.669 0 01-.667-.667c0-.366.3-.666.667-.666h1.667L3.14.194a.672.672 0 01.467-.193h2.786c.174 0 .347.073.467.193l.473.474zM2.333 12c-.733 0-1.333-.6-1.333-1.333V4c0-.733.6-1.333 1.333-1.333h5.334C8.4 2.668 9 3.268 9 4v6.667C9 11.4 8.4 12 7.667 12H2.333z","fill":"#DA1414"}})])
          )
        }
      }
    